import React from 'react'
import { useNavigate } from "react-router-dom";

import { Header } from '../../../component/Typogaphy/Header';
import { BackgroundAuth } from '../../../component/Auth/BackgroundAuth';

import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Divider } from '@mui/material';
import Alert from '@mui/material/Alert';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LoginImage from "../../../assets/images/LoginSecure.gif"


import { FaUserCircle } from "react-icons/fa";

import { pageRoutes } from '../../../routes/pageRoutes';

export const ChangePassword = ({ handleStep }) => {

    const navigate = useNavigate();

    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setConfirmShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickConfirmShowPassword = () => setConfirmShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    return (
        <div className='w-full  bg-white max-w-[800px] rounded-lg p-3 flex flex-col gap-2 drop-shadow-md'>

            <div className='flex flex-row items-center gap-2 w-full justify-between'>
                <div className='max-w-[400px] w-full max-h-[500px] h-full flex flex-col  items-center justify-center'>
                    <img className='h-full w-full' src={LoginImage} alt='N/A' />
                </div>

                <div className='flex flex-col max-w-[800px] w-full  items-center gap-2 px-5 py-2'>
                    <div className='w-full items-center flex flex-col gap-2'>

                        {/* <img
                    className='w-[120px] h-[45px] hidden max-md:block'
                    src={require('../../../assets/images/NBPO_LOGO.png')}
                    alt=''
                /> */}

                        <AccountCircleIcon sx={{ color: '#556fa8' }} fontSize="large" />
                        <Header text={"Change Password"} style={"text-xl font-lexend"} />
                        <span className='text-xs text-[#556fa8] font-semibold self-center'>Company Portal</span>
                    </div>

                    <div className='w-full flex flex-col gap-2 mb-10'>

                        <FormControl variant="outlined" size="small">

                            <div className='w-full flex flex-row items-center justify-between gap-2 my-3'>
                                <span className=' font-medium text-[#556fa8]'>New Password</span>
                            </div>

                            <OutlinedInput
                                id="outlined-adornment-password"
                                placeholder="type here..."
                                type={showPassword ? 'text' : 'password'}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={
                                                showPassword ? 'hide the password' : 'display the password'
                                            }
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>

                        <FormControl variant="outlined" size="small">

                            <div className='w-full flex flex-row items-center justify-between gap-2 my-3'>
                                <span className=' font-medium text-[#556fa8]'>Confirm Password</span>
                            </div>

                            <OutlinedInput
                                id="outlined-adornment-password"
                                placeholder="type here..."
                                type={showConfirmPassword ? 'text' : 'password'}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={
                                                showConfirmPassword ? 'hide the password' : 'display the password'
                                            }
                                            onClick={handleClickConfirmShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>

                        <Alert severity="success">Changes Password Success</Alert>

                        <div onClick={() => navigate(pageRoutes.LOGIN)} className='w-full font-lexend bg-[#2e6b1f] flex flex-col items-center justify-center rounded py-2 cursor-pointer text-white font-medium hover:bg-[#556fa8]'>
                            <span>Change Account Password</span>
                        </div>

                        <div className='mt-2'><Divider /></div>

                        <div className='w-full justify-center flex flex-row gap-2'>
                            <span className='text-black font-light text-sm font-lexend'>Already have an account?</span>
                            <span onClick={() => navigate(pageRoutes.LOGIN)} className='text-[#2e6b1f] font-medium font-lexend text-sm cursor-pointer hover:text-[#556fa8]'>Sign In Now</span>
                        </div>

                    </div>
                </div>
            </div>




        </div>
    )
}
